import {
  SET_ANALYSE_TASK_LIST,
  SET_ANALYSE_TASK_LIST_PAGE,
  SET_ANALYSE_TASK_LIST_PAGE_TOTAL,
  SET_ANALYSE_TASK_LIST_QUERY,
  SET_ANALYSE_TASK_STATE_TYPE,
  SET_ANALYSE_LIST_PAGE_SIZE,
  SET_ANALYSE_SORT,
  SET_ANALYSE_RUNNING_STATUS,
  SET_ANALYSE_END_STATUS,
  SET_ANALYSE_SEARCHING,
  CHANGE_ANALYSE_QUERY,
  RESET_ANALYSE_TASK_LIST_QUERY,
} from './mutation-types'
import api from '@/api'
import {objectTrim} from '@/utils'
import { checkUserName } from '@/views/User/utils'
import _ from 'lodash'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  statusFlag: '',      // [int option] 分析作业标识，0是运行的分析任务，1是完成的分析任务
  userName: '',        // [str option] 用户名
  // userId: '',          // [str option] 用户id
  userIds: [],          // [str option] 用户id
  taskId: '',          // [int option] 平台作业id
  status: '',          // [int option] 状态
  areaId: '',          // [int option] 区域
  analyseIdSort: '',   // [int option] 分析任务id排序字段，0：降序，1：升序
  submitTimeSort: '',  // [int option] 提交时间排序字段，0：降序，1：升序
  startTimeSort: '',   // [int option] 开始时间排序字段，0：降序，1：升序
  endTimeSort: '',     // [int option] 结束时间排序字段，0：降序，1：升序
  userNameSort: '',    // [int option] 用户名排序字段，0：降序，1：升序
  statusSort: '',      // [int option] 状态排序字段，0：降序，1：升序
  properties: '',      // [str option] 属性
  requirements: '',    // [str option] 需求
  constraints: '',     // [str option] 约束
  category: '',        // [str option] 群组
  aiAbnormalCode: '',  // [str option] AI异常原因
})

const analyse = () => ({
  list: [],
  listPageTotal: 0,
  query: initQuery(),
  sort: {
    submitTimeSort: 0,
  },
})

const state = {
  analyseRunning: analyse(),
  analyseEnd: analyse(),
  initQuery: initQuery(),
  groups: [],
  stateType: {},
  initPageSize: 50,
  analyseRunningStatus: [],
  analyseEndStatus: [],
  searching: false,
}

const mutations = {
  [SET_ANALYSE_TASK_LIST] (state, payload) {
    state.stateType.list = payload
  },
  [SET_ANALYSE_TASK_LIST_PAGE] (state, payload) {
    state.stateType.query.pageNum = payload
  },
  [SET_ANALYSE_TASK_LIST_PAGE_TOTAL] (state, payload) {
    state.stateType.listPageTotal = payload
  },
  [SET_ANALYSE_LIST_PAGE_SIZE] (state, payload) {
    state.stateType.query.pageSize = payload
  },
  [SET_ANALYSE_TASK_LIST_QUERY] (state, payload) {
    state.stateType.query = {
      ...state.stateType.query,
      ...payload,
    }
  },
  [RESET_ANALYSE_TASK_LIST_QUERY] (state, payload) {
    state.stateType.query = payload
  },
  [SET_ANALYSE_TASK_STATE_TYPE] (state, payload) {
    state.stateType = payload
  },
  [SET_ANALYSE_SORT] (state, payload) {
    state.stateType.sort = payload
  },
  [SET_ANALYSE_RUNNING_STATUS] (state, payload) {
    state.analyseRunningStatus = payload
  },
  [SET_ANALYSE_END_STATUS] (state, payload) {
    state.analyseEndStatus = payload
  },
  [SET_ANALYSE_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [CHANGE_ANALYSE_QUERY] (state, payload) {
    let statusFlag = payload.statusFlag === 0 ? 'analyseRunning' : 'analyseEnd'
    Reflect.deleteProperty(payload, 'statusFlag')
    state[statusFlag].query = {
      ...state[statusFlag].query,
      ...payload,
    }
  },
}

const actions = {
  // 获取state类型
  getStateType ({commit, state}, statusFlag) {
    switch (statusFlag) {
      case 0:
        commit(SET_ANALYSE_TASK_STATE_TYPE, state.analyseRunning)
        break
      case 1:
        commit(SET_ANALYSE_TASK_STATE_TYPE, state.analyseEnd)
        break
    }
  },
  // 获取运行/完成的分析作业列表
  async setAnalyseTaskList ({commit, state, dispatch}, payload) {
    try {
      dispatch('getStateType', payload.statusFlag)

      const { properties, requirements, constraints, category, ...others } = state.stateType.query
      const getArrayValue = (val) => {
        const strVal = val ? `${val}`.trim() : ''
        return strVal.length ? strVal.split(',') : undefined
      }

      let param = objectTrim({
        properties: getArrayValue(properties),
        requirements: getArrayValue(requirements),
        constraints: getArrayValue(constraints),
        category: getArrayValue(category),
        ...others,
        ...state.stateType.sort,
        statusFlag: payload.statusFlag,
        status: state.stateType.query.status,
        // taskFlag: 4, //无意义字段
      })
      if (payload && payload.userId && param.userName) {
        param.userIds = [String(payload.userId)]
        delete param.userName
      }
      if (payload.statusFlag === 0) {
        delete param.aiAbnormalCode
      }
      // 🤮 后端无法维护旧代码只能在多选时候采用taskStatusList字段
      if (param.status && param.status.length > 1) {
        param = _.omit({
          ...param,
          taskStatusList: param.status,
        }, ['status'])
      } else if (param.status && param.status.length === 1) {
        param.status = param.status[0]
      }
      // Reflect.deleteProperty(param, 'userIds')
      commit(SET_ANALYSE_SEARCHING, true)
      const {data, code} = await api.taskApi.getAnalyseTaskList(param)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = param
          dispatch('setAnalyseTaskList', {
            ...other,
            userId,
          })
        },
      })
      const {items, total} = data
      commit(SET_ANALYSE_SEARCHING, false)
      items.map((itm) => {
        itm.taskFlag = payload.statusFlag === 1 ? 4 : 3
      })
      commit(SET_ANALYSE_TASK_LIST_PAGE_TOTAL, total)
      commit(SET_ANALYSE_TASK_LIST, items)
    } catch (error) {
      console.log(error)
      commit(SET_ANALYSE_SEARCHING, false)
      commit(SET_ANALYSE_TASK_LIST_PAGE_TOTAL, 0)
      commit(SET_ANALYSE_TASK_LIST, [])
    }
  },
  // 初始化列表
  async initAnalyseTaskList ({commit, dispatch, state}, statusFlag) {
    let query = {
      userName: '',
      taskId: '',
      status: '',
      areaId: '',
    }
    commit(SET_ANALYSE_SORT, {submitTimeSort: 0})
    commit(SET_ANALYSE_LIST_PAGE_SIZE, state.initPageSize)
    await dispatch('filterQuery', {query: query, statusFlag: statusFlag})
  },
  // 分析作业列表翻页
  async changeAnalyseTaskListPage ({commit, state, dispatch}, payload) {
    commit(SET_ANALYSE_TASK_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setAnalyseTaskList', payload)
    return Promise.resolve(true)
  },
  // 改变每页显示条数
  async changePageSize ({commit, dispatch}, payload) {
    dispatch('getStateType', payload.statusFlag)
    commit(SET_ANALYSE_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeAnalyseTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag, noXHR: true, status: payload.status})
    return Promise.resolve(true)
  },
  // 分析作业列表筛选
  async changeAnalyseTaskMessageQuery ({commit, dispatch}, statusFlag) {
    await dispatch('changeAnalyseTaskListPage', {currentPage: 1, statusFlag: statusFlag})
  },
  // 列表表头筛选
  async filterQuery ({commit, dispatch}, payload) {
    dispatch('getStateType', payload.statusFlag)
    // commit(SET_ANALYSE_TASK_LIST_QUERY, payload.query) // 取消重置 query, 日期8-19-gt, 需求, 不清楚会产生什么影响
    await dispatch('changeAnalyseTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag, status: payload.query.status})
  },
  // 筛选参数
  setAnalyseQuery ({commit, dispatch, state}, payload) {
    dispatch('getStateType', payload.statusFlag)
    commit(SET_ANALYSE_TASK_LIST_QUERY, payload.query)
  },
  // 重置筛选参数
  resetAnalyseQuery ({commit, state}) {
    commit(RESET_ANALYSE_TASK_LIST_QUERY, state.initQuery)
  },
  // 排序
  changeSort ({commit, dispatch}, payload) {
    commit(SET_ANALYSE_SORT, payload.sort)
    dispatch('changeAnalyseTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag})
  },
  resetSort ({dispatch}, {statusFlag}) {
    dispatch('changeSort', {statusFlag})
  },
  // 获取日志详情
  async setAnalyseTaskLogDetails ({commit, state}, payload) {
    const {code, data} = await api.taskApi.getAnalyseLog(payload)
    return code === 200 ? data : []
  },
  changeAnalyseQuery ({commit}, payload) {
    commit(CHANGE_ANALYSE_QUERY, payload)
  },
  // 清空黑名单
  async cleanAnalyseBlackList ({commit}, payload) {
    const data = await api.taskApi.cleanAnalyseBlackList(payload)
    return data
  },
  // 查看历史分析记录
  async getHistoryAnalyseInfo ({commit}, payload) {
    const {data} = await api.taskApi.getHistoryAnalyseInfo(payload)
    if (data === 'MUNU_NO_RESOURCES') return []
    else return data
  },
}

const getters = {
  analyseModel (state) {
    return state.statusFlag === 0 ? 'analyseRunning' : 'analyseEnd'
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
